/** Where a signed-in website user should land. */
export function webSignedInHome(user: {
  onboardingCompleted?: boolean;
  aiCoachingEnabled?: boolean;
}): string {
  if (!user.onboardingCompleted) return '/onboarding';
  if (!user.aiCoachingEnabled) return '/checkout';
  return '/account';
}
